import React from 'react';
import PropTypes from 'prop-types';

import styles from './Modal.module.scss';

const Click = {
    Esc: 'esc',
    Backdrop: 'backdrop',
    Button: 'button',
};

const Type = {
    Default: 'default',
    Fullscreen: 'fullscreen',
    Out: 'out',
};

const Modal = ({
    transparent, type, onClose, onBack, children,
}) => {

    const classes = React.useMemo((() => [
            styles['modal-component'],
            styles['open'],
            styles[type || Type.Default],
            transparent ? styles['transparent'] : '',
        ].join(' ')
    ), [transparent, type]);

    const handleOnClose = (e) => e.keyCode === 27 && onClose && onClose(Click.Esc);

    React.useEffect(() => {
        document.addEventListener('keydown', handleOnClose);
        return () => {
            document.removeEventListener('keydown', handleOnClose);
        };
    }, []);

    return (
        <div className={classes} onClick={() => onClose && onClose(Click.Backdrop)}>
            <div className={styles['modal-content']} onClick={(e) => e.stopPropagation()}>
                {onBack &&
                    <span className={styles['modal-back']} onClick={onBack}>
                        <i className='icon icon-prev'/>
                    </span>
                }
                <span className={styles['modal-close']} onClick={() => onClose && onClose(Click.Button)}>
                    <i className='icon icon-remove'/>
                </span>
                <div className={styles['modal-body']}>{children}</div>
            </div>
        </div>
    );
};

Modal.propTypes = {
    transparent: PropTypes.bool,
    type: PropTypes.oneOf([
        Type.Default,
        Type.Fullscreen,
        Type.Out,
    ]),
    onClose: PropTypes.func,
    onBack: PropTypes.func,
    children: PropTypes.any,
};

export default Modal;
export {
    Click as ModalClick,
    Type as ModalType,
};
